module.exports = __webpack_public_path__ + "media/images/star-on-ed047c9efe466f26a98afd538a49cada.png";